import React, { useEffect, useRef, useState } from 'react';

import { cleanInput } from "../../../helpers/input";
import Input from './Input';
import Textarea from './Textarea';
import InputDateTime from './InputDateTime';
import InputOTP from './Otp';
import InputHidden from './Hidden';

export default function FieldInput(props) {
    const {
        type = "text",
        helpText = true,
        showcount = false,
        emptyValue = false,
        onKeyDown = () => { },
        onKeyUp = () => { },
        debounce = true,
        ...otherProps
    } = props;

    const { input: { value, onChange } } = otherProps;
    const [currentValue, setCurrentValue] = useState(cleanInput(value));
    const timer = useRef(0);

    useEffect(() => {
        if (emptyValue !== false && !value.toString()) {
            onChange(emptyValue);
        }

        return () => {
            clearTimeout(timer.current)
        }
    }, []);

    useEffect(() => {
        if (value !== currentValue) {
            setCurrentValue(cleanInput(value))
        }
    }, [value])

    const onKeyUpHandler = (e) => {
        const value = cleanInput(e.target.value);
        if (debounce === true) {
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setValue(value, e)
            }, 1000)
        }
        else {
            setValue(value, e)
        }
    }

    const setValue = (value, e) => {
        onKeyUp(value, e);
        onChange(value);
        setCurrentValue(value)
    }

    if (type === "datetime" || type === "date") {
        return (
            <InputDateTime
                type={type}
                helpText={helpText}
                onKeyDown={onKeyDown}
                onKeyUpHandler={onKeyUpHandler}
                {...otherProps}
            />
        )
    }

    if (type === "textarea") {
        return (
            <Textarea
                showcount={showcount}
                currentValue={currentValue}
                onKeyUpHandler={onKeyUpHandler}
                {...otherProps}
            />
        )
    }

    if (type === "otp") {
        return (
            <InputOTP {...props} />
        )
    }
    if (type === "hidden") {
        return (
            <InputHidden {...props} />
        )
    }

    return (
        <Input
            type={type}
            helpText={helpText}
            onKeyDown={onKeyDown}
            onKeyUpHandler={onKeyUpHandler}
            {...otherProps}
        />
    )
}